import {Newspaper, PencilLine, PlusSquare, Trash} from 'lucide-angular';
import { MenuAction } from '@shared/interfaces/header/menu-action';


export const chargeinformationSearchActionMenu: MenuAction[] = [
  {
    id: 'create',
    title: 'action.add',
    icon: PlusSquare
  },
  {
    id: 'edit',
    title: 'meter.edit',
    icon: PencilLine
  },
  {
    id: 'close',
    title: 'action.close',
    icon: Trash,
    iconColor: 'text-red-500',
    disabled: true,
  },
  {
    id: 'requestInformation',
    title: 'chargeInformation.requestChargeInformation',
    icon: Newspaper
  },
];
